export default __webpack_public_path__ + "static/media/Group 1171276202 (2).128500d3.svg";